import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const sevaApi = createApi({
    reducerPath: "sevaApi",
    baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
    endpoints: (builder) => ({
        getSevaCategories: builder.query({
            query: () => "/seva-categories",
        }),
        getSevasByCategory: builder.query({
            query: (categoryId) => ({
                url: "/sevas",
                method: "POST",
                body: { category_id: categoryId },
            }),
        }),
    }),
});

export const { useGetSevaCategoriesQuery, useGetSevasByCategoryQuery } = sevaApi;
